import { IPublicDesktopV2MapGetConfigResponse } from 'shared/repositories/commercial-listing-map/desktop/v2/map/get-config';

export type MapInitialStatePartial = {
  center: YMaps.IMapState['center'];
  zoom: YMaps.IMapState['zoom'];
};

export function mapPreparedConfigSelector(data: IPublicDesktopV2MapGetConfigResponse): MapInitialStatePartial {
  return {
    center: [data.center.lat, data.center.lng],
    zoom: data.zoom,
  };
}
